module.exports = __webpack_public_path__ + "static/media/Coroa.ae91ae19.svg";